// Copyright aptihealth, inc. 2021 All Rights Reserved
import React, { Fragment } from "react";
import { eventTypeDisplayNameFactory } from "../../../ScheduleAvailability/ActiveScheduleDetails";
import moment from "moment";

const CareCommunicationView = (props) => {
  const { note } = props;

  const renderSecondaryDiagnosis = () => {
    if (!note.ICD_10_axis_2_diagnosis) {
      return <div>None</div>;
    }

    if (note.ICD_10_axis_2_diagnosis.length > 0) {
      return note.ICD_10_axis_2_diagnosis.map((diagnosis, index) => (
        <div key={diagnosis.code || diagnosis.value || index}>{diagnosis.value}</div>
      ));
    }

    return <div>None</div>;
  };

  return (
    <div className={"w-100"}>
      <div className={"row print-wrap"}>
        <div className={"col-12 tw:font-bold"}>Care Communication Note</div>

        <div className="border-bottom col-12 my-2" />

        <div className={"col-lg-3 mb-2"}>
          <div className={"tw:font-bold"}>Communication Type</div>
          <div>{note.content.communication_type}</div>
        </div>

        <div className={"col-lg-3 mb-2"}>
          <div className={"tw:font-bold"}>Date & Time</div>
          <div>
            {moment(note.session_date + " " + note.session_from, "MM/DD/YYYY hh:mm").format(
              "MM/DD/YYYY hh:mm a",
            )}
          </div>
        </div>

        <div className={"col-lg-3 mb-2"}>
          <div className={"tw:font-bold"}>CPT Description</div>
          <div>{eventTypeDisplayNameFactory(note.call_type)}</div>
        </div>

        <div className={"col-lg-3 mb-2"}>
          <div className={"tw:font-bold"}>Reason For Communication</div>
          {note.content.reason_for_communication.map((reason, index) => {
            if (reason === "Other (open text)" && note.content.reason_for_communication_other) {
              reason = "Other: " + note.content.reason_for_communication_other;
            }
            return <div key={reason + index}>{reason}</div>;
          })}
        </div>

        {note.content.encounters.map((encounter, index) => {
          return (
            <Fragment key={encounter.encounter_date + index}>
              <div className="border-bottom col-12 my-2" />

              <div className={"col-lg-3 mb-2"}>
                <div className={"tw:font-bold"}>Encounter Date</div>
                <div>{encounter.encounter_date}</div>
              </div>

              {encounter.discharge_date && (
                <div className={"col-lg-3 mb-2"}>
                  <div className={"tw:font-bold"}>Discharge Date</div>
                  <div>{encounter.discharge_date}</div>
                </div>
              )}

              <div className={"col-lg-3 mb-2"}>
                <div className={"tw:font-bold"}>Encounter Type</div>
                {encounter.encounter_type.map((type, typeIndex) => (
                  <div key={type + typeIndex}>{type}</div>
                ))}
              </div>

              {encounter.discharge_type.length > 0 && (
                <div className={"col-lg-3 mb-2"}>
                  <div className={"tw:font-bold"}>Discharge Type</div>
                  {encounter.discharge_type.map((type, typeIndex) => (
                    <div key={type + typeIndex}>{type}</div>
                  ))}
                </div>
              )}

              <div className={"col-lg-3 mb-2"}>
                <div className={"tw:font-bold"}>Setting</div>
                {encounter.setting.map((setting, settingIndex) => {
                  if (setting === "Other (open text)" && encounter.setting_other) {
                    setting = "Other: " + encounter.setting_other;
                  }
                  return <div key={setting + settingIndex}>{setting}</div>;
                })}
              </div>

              <div className={"col-lg-12 mb-2"}>
                <div className={"tw:font-bold"}>Encounter Information</div>
                <div>{encounter.encounter_information}</div>
              </div>
            </Fragment>
          );
        })}

        <div className="border-bottom col-12 my-2" />

        <div className={"col-lg-12 mb-2"}>
          <div className={"tw:font-bold"}>Communication & Plan</div>
          <div className={"break-spaces"}>{note.content.communication_and_plan}</div>
        </div>

        <div className={"col-lg-6 mb-2"}>
          <div className={"tw:font-bold"}>Primary Diagnosis</div>
          {note.ICD_10_axis_1_diagnosis &&
            note.ICD_10_axis_1_diagnosis.length > 0 &&
            note.ICD_10_axis_1_diagnosis.map((diagnosis, index) => (
              <div key={diagnosis.code || diagnosis.value || index}>{diagnosis.value}</div>
            ))}
          {note.ICD_10_axis_1_diagnosis && note.ICD_10_axis_1_diagnosis.length === 0 && (
            <div>None</div>
          )}
          {!note.ICD_10_axis_1_diagnosis && <div>None</div>}
        </div>

        <div className={"col-lg-6 mb-2"}>
          <div className={"tw:font-bold"}>Secondary Diagnosis</div>
          {renderSecondaryDiagnosis()}
        </div>
      </div>
    </div>
  );
};

export default CareCommunicationView;
